import React from 'react';
import { ReactComponent as FilterAltSvg } from '../../../assets/svg/filter-alt.svg';
import { ReactComponent as MegaphoneSvg } from '../../../assets/svg/megaphone.svg';
import { ReactComponent as CommunityAvatar1Svg } from '../../../assets/svg/community-avatar-01.svg';
import { ReactComponent as CommunityAvatar2Svg } from '../../../assets/svg/community-avatar-02.svg';
import { ReactComponent as CommunityAvatar3Svg } from '../../../assets/svg/community-avatar-03.svg';
import { ReactComponent as CommunityAvatar4Svg } from '../../../assets/svg/community-avatar-04.svg';
import { ReactComponent as CommunityAvatar5Svg } from '../../../assets/svg/community-avatar-05.svg';
import { ReactComponent as CommunityAvatar6Svg } from '../../../assets/svg/community-avatar-06.svg';
import { ReactComponent as CommunityAvatar7Svg } from '../../../assets/svg/community-avatar-07.svg';
import { ReactComponent as CommunityAvatar8Svg } from '../../../assets/svg/community-avatar-08.svg';
import { ReactComponent as FolderLockedSvg } from '../../../assets/svg/folder-locked.svg';
import { ReactComponent as FolderOpenSvg } from '../../../assets/svg/folder-open.svg';
import { ReactComponent as FolderOpenFillSvg } from '../../../assets/svg/folder-open-fill.svg';
import { ReactComponent as HomeSvg } from '../../../assets/svg/home.svg';
import { ReactComponent as HomeFillSvg } from '../../../assets/svg/home-fill.svg';
import { ReactComponent as JournalMedicalSvg } from '../../../assets/svg/journal-medical.svg';
import { ReactComponent as JournalMedicalFillSvg } from '../../../assets/svg/journal-medical-fill.svg';
import { ReactComponent as JournalMedicalFillInvertedSvg } from '../../../assets/svg/journal-medical-fill-inverted.svg';
import { ReactComponent as CardSvg } from '../../../assets/svg/card.svg';
import { ReactComponent as BookkeepingSvg } from '../../../assets/svg/bookkeeping.svg';
import { ReactComponent as ReportSvg } from '../../../assets/svg/report.svg';
import { ReactComponent as LightBulbSvg } from '../../../assets/svg/lightbulb-fill.svg';
import { ReactComponent as PeopleSvg } from '../../../assets/svg/people.svg';
import { ReactComponent as PeopleFillSvg } from '../../../assets/svg/people-fill.svg';
import { ReactComponent as RequestSvg } from '../../../assets/svg/request.svg';
import { ReactComponent as RequestFillSvg } from '../../../assets/svg/request-fill.svg';
import { ReactComponent as CalendarSvg } from '../../../assets/svg/calendar.svg';
import { ReactComponent as GetPaidFillSvg } from '../../../assets/svg/get-paid-fill.svg';
import { ReactComponent as GearSvg } from '../../../assets/svg/gear.svg';
import { ReactComponent as GearFillSvg } from '../../../assets/svg/gear-fill.svg';
import { ReactComponent as PayFillSvg } from '../../../assets/svg/pay-fill.svg';
import { ReactComponent as ArrowLeftRightSvg } from '../../../assets/svg/arrow-left-right.svg';
import { ReactComponent as ChartOfAccountsSvg } from '../../../assets/svg/chart-of-accounts.svg';
import { ReactComponent as JournalEntriesSvg } from '../../../assets/svg/journal-entries.svg';
import { ReactComponent as BudgetSvg } from '../../../assets/svg/budget.svg';
import { ReactComponent as BudgetingSvg } from '../../../assets/svg/budgeting.svg';
import { ReactComponent as Reports } from '../../../assets/svg/reports.svg';
import { ReactComponent as ApAgingDetailSvg } from '../../../assets/svg/reports/ap-aging-detail.svg';
import { ReactComponent as ApAgingSummarySvg } from '../../../assets/svg/reports/ap-aging-summary.svg';
import { ReactComponent as ArAgingDetailSvg } from '../../../assets/svg/reports/ar-aging-detail.svg';
import { ReactComponent as ArAgingSummarySvg } from '../../../assets/svg/reports/ar-aging-summary.svg';
import { ReactComponent as BalanceSheetSvg } from '../../../assets/svg/reports/balance-sheet.svg';
import { ReactComponent as BankReconciliationSvg } from '../../../assets/svg/reports/bank-reconciliation.svg';
import { ReactComponent as BudgetComparisonSvg } from '../../../assets/svg/reports/budget-comparison.svg';
import { ReactComponent as CashFlowSvg } from '../../../assets/svg/reports/cash-flow.svg';
import { ReactComponent as ExpenseDetailsSvg } from '../../../assets/svg/reports/expense-details.svg';
import { ReactComponent as GeneralLedgerSvg } from '../../../assets/svg/reports/general-ledger.svg';
import { ReactComponent as InvoiceDetailsSvg } from '../../../assets/svg/reports/invoice-details.svg';
import { ReactComponent as JournalReportSvg } from '../../../assets/svg/reports/journal-report.svg';
import { ReactComponent as ProfitAndLossSvg } from '../../../assets/svg/reports/profit-and-loss.svg';
import { ReactComponent as TrialBalanceSvg } from '../../../assets/svg/reports/trial-balance.svg';
import { ReactComponent as StatusApprovedSvg } from '../../../assets/svg/status-approved.svg';
import { ReactComponent as StatusApprovedInvertedSvg } from '../../../assets/svg/status-approved-inverted.svg';
import { ReactComponent as StatusDeclinedSvg } from '../../../assets/svg/status-declined.svg';
import { ReactComponent as StatusDeclinedInvertedSvg } from '../../../assets/svg/status-declined-inverted.svg';
import { ReactComponent as StatusInProgressSvg } from '../../../assets/svg/status-in-progress.svg';
import { ReactComponent as StatusInProgressInvertedSvg } from '../../../assets/svg/status-in-progress-inverted.svg';
import { ReactComponent as StatusInfoRequestedSvg } from '../../../assets/svg/status-info-requested.svg';
import { ReactComponent as StatusInfoRequestedInvertedSvg } from '../../../assets/svg/status-info-requested-inverted.svg';
import classNames from 'classnames';

export type ForestIcon =
  // General.
  | 'filter-alt'
  | 'megaphone'
  | 'community-avatar-1'
  | 'community-avatar-2'
  | 'community-avatar-3'
  | 'community-avatar-4'
  | 'community-avatar-5'
  | 'community-avatar-6'
  | 'community-avatar-7'
  | 'community-avatar-8'
  | 'folder-locked'
  // Side nav.
  | 'folder-open'
  | 'folder-open-fill'
  | 'home'
  | 'home-fill'
  | 'journal-medical'
  | 'journal-medical-fill'
  | 'journal-medical-fill-inverted'
  | 'people'
  | 'people-fill'
  | 'request'
  | 'request-fill'
  | 'gear'
  | 'gear-fill'
  | 'get-paid-fill'
  | 'pay-fill'
  | 'calendar'
  | 'card'
  | 'insight'
  | 'bookkeeping'
  | 'report'
  // Profile nav.
  | 'arrow-left-right'
  // Accounting.
  | 'charts-of-accounts'
  | 'journal-entries'
  | 'budget'
  | 'budgeting'
  | 'reports'
  // Reporting.
  | 'ap-aging-detail'
  | 'ap-aging-summary'
  | 'ar-aging-detail'
  | 'ar-aging-summary'
  | 'balance-sheet'
  | 'bank-reconciliation'
  | 'budget-comparison'
  | 'cash-flow'
  | 'expense-details'
  | 'general-ledger'
  | 'invoice-details'
  | 'journal-report'
  | 'profit-and-loss'
  | 'trial-balance'
  // Requests.
  | 'status-approved'
  | 'status-approved-inverted'
  | 'status-declined'
  | 'status-declined-inverted'
  | 'status-in-progress'
  | 'status-in-progress-inverted'
  | 'status-info-requested'
  | 'status-info-requested-inverted';

type SvgProps = React.SVGProps<SVGSVGElement> & { title?: string };

export const forestIconMap: Record<ForestIcon, React.FunctionComponent<SvgProps>> = {
  // General.
  'filter-alt': FilterAltSvg,
  megaphone: MegaphoneSvg,
  'community-avatar-1': CommunityAvatar1Svg,
  'community-avatar-2': CommunityAvatar2Svg,
  'community-avatar-3': CommunityAvatar3Svg,
  'community-avatar-4': CommunityAvatar4Svg,
  'community-avatar-5': CommunityAvatar5Svg,
  'community-avatar-6': CommunityAvatar6Svg,
  'community-avatar-7': CommunityAvatar7Svg,
  'community-avatar-8': CommunityAvatar8Svg,
  'folder-locked': FolderLockedSvg,
  // Side nav.
  'folder-open': FolderOpenSvg,
  'folder-open-fill': FolderOpenFillSvg,
  home: HomeSvg,
  'home-fill': HomeFillSvg,
  'journal-medical': JournalMedicalSvg,
  'journal-medical-fill': JournalMedicalFillSvg,
  'journal-medical-fill-inverted': JournalMedicalFillInvertedSvg,
  calendar: CalendarSvg,
  people: PeopleSvg,
  'people-fill': PeopleFillSvg,
  request: RequestSvg,
  'request-fill': RequestFillSvg,
  gear: GearSvg,
  'gear-fill': GearFillSvg,
  'get-paid-fill': GetPaidFillSvg,
  'pay-fill': PayFillSvg,
  card: CardSvg,
  insight: LightBulbSvg,
  bookkeeping: BookkeepingSvg,
  report: ReportSvg,
  // Profile nav.
  'arrow-left-right': ArrowLeftRightSvg,
  // Accounting
  'charts-of-accounts': ChartOfAccountsSvg,
  'journal-entries': JournalEntriesSvg,
  budgeting: BudgetingSvg,
  reports: Reports,
  budget: BudgetSvg,
  // Reporting
  'ap-aging-detail': ApAgingDetailSvg,
  'ap-aging-summary': ApAgingSummarySvg,
  'ar-aging-detail': ArAgingDetailSvg,
  'ar-aging-summary': ArAgingSummarySvg,
  'balance-sheet': BalanceSheetSvg,
  'bank-reconciliation': BankReconciliationSvg,
  'budget-comparison': BudgetComparisonSvg,
  'cash-flow': CashFlowSvg,
  'expense-details': ExpenseDetailsSvg,
  'general-ledger': GeneralLedgerSvg,
  'invoice-details': InvoiceDetailsSvg,
  'journal-report': JournalReportSvg,
  'profit-and-loss': ProfitAndLossSvg,
  'trial-balance': TrialBalanceSvg,
  // Requests.
  'status-approved': StatusApprovedSvg,
  'status-approved-inverted': StatusApprovedInvertedSvg,
  'status-declined': StatusDeclinedSvg,
  'status-declined-inverted': StatusDeclinedInvertedSvg,
  'status-in-progress': StatusInProgressSvg,
  'status-in-progress-inverted': StatusInProgressInvertedSvg,
  'status-info-requested': StatusInfoRequestedSvg,
  'status-info-requested-inverted': StatusInfoRequestedInvertedSvg,
};

const Icon: React.FunctionComponent<SvgProps & { name: ForestIcon }> = ({ name, ...svgProps }) => {
  const Component = forestIconMap[name];
  return <Component {...svgProps} className={classNames('flex-shrink-0', svgProps.className)} />;
};

export default Icon;
